import React from 'react'

const CateringBanner = () => {
  return <div className="header-banner">🍽 Introducing MealPal catering! 🍽</div>
}

export default CateringBanner
